import { supabase } from './supabase';
import { translate } from '../i18n/messages';
import { formatWhen } from './format';

export const JOURNEY_STAGES = [
  'vehicle_received',
  'initial_inspection',
  'computer_diagnosis',
  'quotation_prepared',
  'awaiting_customer_approval',
  'spare_parts_requested',
  'repair_in_progress',
  'quality_inspection',
  'car_wash',
  'ready_for_collection',
];

export const JOURNEY_GROUPS = [
  {
    id: 'intake',
    stages: ['vehicle_received', 'initial_inspection', 'computer_diagnosis'],
  },
  {
    id: 'estimate',
    stages: ['quotation_prepared', 'awaiting_customer_approval'],
  },
  {
    id: 'repair',
    stages: ['spare_parts_requested', 'repair_in_progress'],
  },
  {
    id: 'finish',
    stages: ['quality_inspection', 'car_wash', 'ready_for_collection'],
  },
];

export function journeyStageLabel(stage) {
  if (!stage) return '—';
  return translate(`journey.${stage}`);
}

export function journeyStageRank(stage) {
  const index = JOURNEY_STAGES.indexOf(stage);
  return index === -1 ? 0 : index + 1;
}

export function nextJourneyStage(stage) {
  const index = JOURNEY_STAGES.indexOf(stage);
  if (index === -1) return JOURNEY_STAGES[0];
  if (index >= JOURNEY_STAGES.length - 1) return null;
  return JOURNEY_STAGES[index + 1];
}

export function journeySteps(row) {
  const current = row?.journey_stage || null;
  const currentRank = journeyStageRank(current);
  const stamps = row?.journey_stage_at || {};

  return JOURNEY_GROUPS.map((group) => ({
    ...group,
    label: translate(`journey.group.${group.id}`),
    steps: group.stages.map((id) => {
      const rank = journeyStageRank(id);
      const raw = stamps[id];
      return {
        id,
        title: journeyStageLabel(id),
        when: raw ? formatWhen(raw) : '',
        done: currentRank >= rank && rank > 0,
        current: id === current,
      };
    }),
  }));
}

export async function updateBookingJourneyStage(id, stage) {
  const { data, error } = await supabase.rpc('set_booking_journey_stage', {
    p_booking_id: id,
    p_stage: stage,
  });
  if (error) return { error };
  return { data };
}
